import { Component, OnInit } from '@angular/core';
import { SetupService } from '@core/services/setup';

import { DEPARTMENT_TYPE_WHEELCHAIR } from 'src/app/core/constants';

@Component({
  selector: 'app-wheelchair-home',
  templateUrl: './wheelchair-home.component.html',
  styleUrls: ['./wheelchair-home.component.scss']
})
export class WheelchairHomeComponent implements OnInit {
  /**
   * Definição da identificão da sessão/depto Cadeirantes
   */
  public departmentType: string = DEPARTMENT_TYPE_WHEELCHAIR;

  constructor(public setupService: SetupService) { }

  ngOnInit(): void {
  }

}
